export interface Country {
   name: string;
   code: string;
   dialCode: string;
   flag: string;
}

export const COUNTRIES: Country[] = [
   { name: 'United States', code: 'US', dialCode: '+1', flag: '🇺🇸' },
   { name: 'Nigeria', code: 'NG', dialCode: '+234', flag: '🇳🇬' },
];

